import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'
export type ExecuteWasteRequest = {
  batchId: string
  deviceId: string
  pin: string
  executionNote: string
  photoCount: number
  photoUrls?: string[]
}

export type ExecuteWasteResponse = {
  executed_at: string
}

const DEV_PIN = '123456'

function useMockApi(): boolean {
  return isMockApi
}

function mockExecute(req: ExecuteWasteRequest): ExecuteWasteResponse {
  if (req.pin !== DEV_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }
  if (!req.executionNote.trim()) {
    throw new Error('Catatan pemusnahan wajib diisi.')
  }
  if (req.photoCount < 1) {
    throw new Error('Minimal 1 foto bukti pemusnahan.')
  }
  return { executed_at: new Date().toISOString() }
}

export async function executeWasteBatchDirect(
  req: ExecuteWasteRequest,
): Promise<ExecuteWasteResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockExecute(req)
  }

  return apiFetch<ExecuteWasteResponse>(`/kitchen/waste-batches/${req.batchId}/execute`, {
    method: 'POST',
    body: JSON.stringify({
      device_id: req.deviceId,
      pin: req.pin,
      execution_note: req.executionNote,
      photo_count: req.photoCount,
      photo_urls: req.photoUrls ?? [],
    }),
  })
}

export async function executeWasteBatch(req: ExecuteWasteRequest): Promise<ExecuteWasteResponse> {
  return runKitchenSync(
    {
      type: 'waste_execute',
      label: `Eksekusi pemusnahan ${req.batchId}`,
      payload: req,
    },
    () => executeWasteBatchDirect(req),
    () => ({ executed_at: new Date().toISOString() }),
  )
}
